import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=5e1c56b3&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=5e1c56b3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1c56b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e1c56b3')) {
      api.createRecord('5e1c56b3', component.options)
    } else {
      api.reload('5e1c56b3', component.options)
    }
    module.hot.accept("./UserInfo.vue?vue&type=template&id=5e1c56b3&scoped=true", function () {
      api.rerender('5e1c56b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/UserInfo.vue"
export default component.exports